// This file is generated by a script. Do not edit this file directly.
(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "react"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("react"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react);
    global.Files = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _react) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.Files = void 0;
  _react = _interopRequireDefault(_react);
  function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
  function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
  var Files = _exports.Files = function Files(props) {
    return /*#__PURE__*/_react["default"].createElement("svg", _extends({
      viewBox: "0 0 20 20",
      fill: "none"
    }, props), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M0 3.75C0 2.37109 1.12109 1.25 2.5 1.25H7.66016C8.40625 1.25 9.12109 1.54687 9.64844 2.07422L11.3242 3.75H17.5C18.8789 3.75 20 4.87109 20 6.25V16.25C20 17.6289 18.8789 18.75 17.5 18.75H2.5C1.12109 18.75 0 17.6289 0 16.25V3.75ZM2.5 3.125C2.15625 3.125 1.875 3.40625 1.875 3.75V16.25C1.875 16.5938 2.15625 16.875 2.5 16.875H17.5C17.8438 16.875 18.125 16.5938 18.125 16.25V6.25C18.125 5.90625 17.8438 5.625 17.5 5.625H11.1953C10.7812 5.625 10.3828 5.46094 10.0898 5.16797L8.32422 3.39844C8.14844 3.22266 7.91016 3.125 7.66016 3.125H2.5Z",
      fill: "currentColor"
    }));
  };
});
